var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[ _vm.containerClass, {
  'border-b-2 border-input-border flex mb-8': !_vm.overwriteContainerClass
}]},[_c('h1',{class:[ _vm.headingClass, {
    'font-bold py-5 text-2xl md:text-3xl font-display text-black': !_vm.overwriteHeadingClass
  }],domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }